import { apiCall } from './generated/gqlClient';

const getCurrentProviderCityApiRequest = () => {
  const query = `
    query getCurrentProviderCity {
      getCurrentProviderCity {
        id
        name
        latitude
        longitude
      }
    }
  `;

  return apiCall({ query });
};

const getProvidersForLandingApiRequest = async (onlyActive, categoryId, cityId, providerType, keyword, onlyMyMemberships) => {
  const query = `
    query getProviders($categoryId: Int, $cityId: Int, $providerType: String, $keyword: String, $onlyMyMemberships: Boolean, $onlyActive: Boolean) {
      getProviders(
        categoryId: $categoryId
        cityId: $cityId
        providerType: $providerType
        keyword: $keyword
        onlyMyMemberships: $onlyMyMemberships
        onlyActive: $onlyActive
      ) {
        id
        name
        type
        description
        address
        images {
          medium
        }
        categories {
          id
          name
        }
      }
    }
  `;
  return apiCall({ query, variables: { onlyActive, categoryId, cityId, providerType, keyword, onlyMyMemberships } });
};

export { getCurrentProviderCityApiRequest, getProvidersForLandingApiRequest };
